
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1104Dialog extends Serenity.EntityDialog<Report_1104Row, any> {
        protected getFormKey() { return Report_1104Form.formKey; }
        protected getIdProperty() { return Report_1104Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1104Row.localTextPrefix; }
        protected getNameProperty() { return Report_1104Row.nameProperty; }
        protected getService() { return Report_1104Service.baseUrl; }
        protected getDeletePermission() { return Report_1104Row.deletePermission; }
        protected getInsertPermission() { return Report_1104Row.insertPermission; }
        protected getUpdatePermission() { return Report_1104Row.updatePermission; }

        protected form = new Report_1104Form(this.idPrefix);

    }
}